import { FiArrowLeft, FiImage, FiPercent, FiSunset } from "react-icons/fi";
import { useParams } from "react-router-dom";
import NavCard from "../../Partials/Layouts/NavCardList/NavCard/NavCard";
import NavCardList from "../../Partials/Layouts/NavCardList/NavCardList";

function OrganizationCards() {

    const {organizationID} = useParams()

    return (
        <NavCardList numOfCards={'four_nav_cards_list'}>
            <NavCard cardName='Organization Stat Cards' navCardLink={'/organizationStatCards/' + organizationID}>
                <FiPercent />
            </NavCard>
            <NavCard cardName='Organization NDI Cards' navCardLink={'/organizationNDICards/' + organizationID}>
                <FiSunset />
            </NavCard>
            <NavCard cardName='Organization NI Cards' navCardLink={'/organizationNICards/' + organizationID}>
                <FiImage />
            </NavCard>
            <NavCard cardName='Go Back' navCardLink={'/organizations/'}>
                <FiArrowLeft />
            </NavCard>
        </NavCardList>
    )
}

export default OrganizationCards